import { createIdSlice } from '../utils/action/createElementSlice';
export const BreadcrumbState = createIdSlice({
    elementName: 'breadcrumb',
    initialState: {},
    reducers: {
        setBasicData: (state = [], action) => {
            // TODO: Return the old state if nothing needs to change.
            return action.payload.data.map((value, i) => updateHierarchy(state[i], value));
        },
        updateBreadcrumb: (state = [], action) => {
            const { target, labels } = action.payload.data;
            const hierarchyIndex = indexOfName(state, target.name);
            if (hierarchyIndex === -1)
                return state;
            const targetData = state[hierarchyIndex];
            const items = [...targetData.items];
            const oldItem = items[target.index];
            if (oldItem.isSingle)
                return state;
            const oldLabel = oldItem.values[oldItem.selectedIndex];
            const labelIndex = labels.indexOf(oldLabel);
            // Special case for when the current item was not found (likely due to filters)
            const values = labelIndex === -1 ? [oldLabel, ...labels] : labels;
            const selectedIndex = labelIndex === -1 ? 0 : labelIndex;
            items[target.index] = Object.assign(Object.assign({}, oldItem), { values,
                selectedIndex, status: 'complete' });
            const newState = [...state];
            newState[hierarchyIndex] = Object.assign(Object.assign({}, targetData), { items });
            return newState;
        },
        selectBreadcrumb: (state, _action) => {
            return state;
        },
        selectBreadcrumbItem: (state, _action) => {
            return state;
        },
        openBreadcrumb: (state, _action) => {
            return state;
        },
    },
});
function indexOfName(state, name) {
    return state.findIndex((bc) => bc.name === name);
}
function updateHierarchy(current, update) {
    if (current && current.name === update.name) {
        return Object.assign(Object.assign({}, current), { 
            // NOTE: VA can update a label after a breadcrumb already exists.
            label: update.label, items: update.items.map((item, i) => updateItem(current.items[i], item)) });
    }
    return Object.assign(Object.assign({}, update), { items: update.items.map((item) => updateItem(undefined, item)) });
}
function updateItem(current, update) {
    if (current) {
        const index = current.values.indexOf(update);
        if (index !== -1) {
            return Object.assign(Object.assign({}, current), { selectedIndex: index, status: 'invalid' });
        }
    }
    return {
        isSingle: false,
        selectedIndex: 0,
        status: 'initial',
        values: [update],
    };
}
